import { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { isPushSupported, getCurrentSubscription, subscribePush, unsubscribePush } from "../lib/push";

export default function PushToggle() {
  const [supported, setSupported] = useState(false);
  const [active, setActive] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    (async () => {
      const ok = await isPushSupported();
      setSupported(ok);
      if (ok) {
        const sub = await getCurrentSubscription();
        setActive(!!sub && Notification.permission === "granted");
      }
    })();
  }, []);

  if (!supported) return null;

  const toggle = async () => {
    setMsg("");
    setBusy(true);
    try {
      if (active) {
        await unsubscribePush();
        setActive(false);
      } else {
        await subscribePush();
        setActive(true);
      }
    } catch (e) {
      setMsg(e.message || "Failed to toggle notifications");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="glass p-5" data-testid="push-toggle">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="flex items-center gap-2 font-mono-cosmic text-[10px] tracking-[0.35em] text-[#00ffff] uppercase mb-1">
            <Bell className="w-3.5 h-3.5" /> Cosmic Alerts
          </div>
          <div className="font-heading uppercase text-sm tracking-tight text-white">
            Daily Runs &middot; Weekly Featured Missions
          </div>
          <p className="text-white/55 text-xs mt-1">
            Browser ping at 00:00 UTC daily (new seed) and Monday 00:00 UTC (2&times; bonus rotation).
          </p>
          {msg && (
            <div className="mt-2 text-[11px] font-mono-cosmic text-[#ff007f] tracking-widest uppercase">
              {msg}
            </div>
          )}
        </div>
        <button
          onClick={toggle}
          disabled={busy}
          className="btn-neon cyan disabled:opacity-50"
          style={{ padding: "0.5rem 0.9rem" }}
          data-testid="push-toggle-btn"
        >
          <span className="inline-flex items-center gap-2">
            {active ? <BellOff className="w-4 h-4" /> : <Bell className="w-4 h-4" />}
            {active ? "On" : "Enable"}
          </span>
        </button>
      </div>
    </div>
  );
}
